// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Store = require("../../../shared/src/Store.bs.js");

function webStoreErrorToString(param) {
  if (param) {
    if (param._0) {
      return "Web::ParseError:ResponseParse";
    } else {
      return "Web::ParseError:JwtParse";
    }
  } else {
    return "Web::UpdatePageMarkerAndShiftsError";
  }
}

function dispatchErrorToString(param) {
  return Store.dispatchErrorToString(webStoreErrorToString, param);
}

exports.webStoreErrorToString = webStoreErrorToString;
exports.dispatchErrorToString = dispatchErrorToString;
/* Store Not a pure module */
